import type { DOMConversionMap } from "lexical";
import { $applyNodeReplacement } from "lexical";
import type { JSX } from "react";
import type { UUID } from "../../../../../utils/uuid";
import { PollComponent } from "./component/poll-component";
import { convertPollElement, isPollElement } from "./export";
import { PollNode } from "./poll-node";
import type { PollNodeAnswerType, SerializedPollNode } from "./types";

export class PollNodeMui extends PollNode {
  decorate(): JSX.Element {
    return (
      <PollComponent
        format={this.__format}
        nodeKey={this.__key}
        pollId={this.__poll_id}
        answer_type={this.__answer_type}
        refresh_id={this.__refresh_id}
      />
    );
  }

  static importJSON(serializedNode: SerializedPollNode): PollNodeMui {
    return super.importJSON(serializedNode);
  }

  exportJSON(): SerializedPollNode {
    return super.exportJSON();
  }

  static clone(node: PollNodeMui): PollNodeMui {
    return super.clone(node);
  }

  static getType(): string {
    return super.getType();
  }

  static importDOM(): DOMConversionMap | null {
    return {
      div: (node: HTMLElement) => {
        if (!isPollElement(node)) return null;

        return {
          conversion: (n) => convertPollElement(n, PollNodeMui),
          priority: 0,
        };
      },
    };
  }
}

export function $createPollNode(
  headless: boolean,
  pollId: UUID,
  answerType: PollNodeAnswerType,
): PollNode {
  return $applyNodeReplacement(new (headless ? PollNode : PollNodeMui)(pollId, answerType));
}
